// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const BackToResults = () => ({
   bindToController: {
      callback: '&'
   },

   controllerAs: 'vm',
   controller: BackToResultsController,
   replace: true,

   template:   '<button tabindex="0" class="navigateBackLink summonBtn" ng-click="vm.callback()">' +
                    '<i class="uxf-icon uxf-left-open" aria-hidden="true"></i>' +
                    '<span ng-bind="::i18n.translations.BACK_TO_SEARCH"></span>' +
                '</button>'
})

class BackToResultsController {
   constructor() {}
}

angular.module('summonApp.directives')
   .controller('backToResultsController', BackToResultsController)
   .directive('backToResults', BackToResults)
